module.exports = __webpack_public_path__ + "img/brand-08.c40a3f33.png";